import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _wrapNativeSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import fetcher from "@/common/axiosInstance";
import UnprocessableEntityError from "@/exceptions/UnprocessableEntityError";
import { ValidationException } from "@/common/exceptions/ValidationException";
export var OrderPaidError = /*#__PURE__*/function (_UnprocessableEntityE) {
  function OrderPaidError() {
    var _this;
    _classCallCheck(this, OrderPaidError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, OrderPaidError, [].concat(args));
    _defineProperty(_this, "name", "OrderPaidError");
    return _this;
  }
  _inherits(OrderPaidError, _UnprocessableEntityE);
  return _createClass(OrderPaidError);
}(UnprocessableEntityError);
export var PostReservedError = /*#__PURE__*/function (_UnprocessableEntityE2) {
  function PostReservedError() {
    var _this2;
    _classCallCheck(this, PostReservedError);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _callSuper(this, PostReservedError, [].concat(args));
    _defineProperty(_this2, "name", "PostReservedError");
    return _this2;
  }
  _inherits(PostReservedError, _UnprocessableEntityE2);
  return _createClass(PostReservedError);
}(UnprocessableEntityError);
export var TabbyValidationError = /*#__PURE__*/function (_Error) {
  function TabbyValidationError(validationErrors) {
    var _this3;
    _classCallCheck(this, TabbyValidationError);
    _this3 = _callSuper(this, TabbyValidationError, ["Validation error"]);
    _this3.name = "TabbyValidationError";
    _this3.validationErrors = validationErrors;
    return _this3;
  }
  _inherits(TabbyValidationError, _Error);
  return _createClass(TabbyValidationError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export var TabbyRejectionError = /*#__PURE__*/function (_UnprocessableEntityE3) {
  function TabbyRejectionError(message, rejectionReason) {
    var _this4;
    _classCallCheck(this, TabbyRejectionError);
    _this4 = _callSuper(this, TabbyRejectionError, [message]);
    _this4.name = "TabbyRejectionError";
    _this4.rejectionReason = rejectionReason;
    return _this4;
  }
  _inherits(TabbyRejectionError, _UnprocessableEntityE3);
  return _createClass(TabbyRejectionError);
}(UnprocessableEntityError);
export var api__createTabbyCheckoutSession = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(requestData) {
    var _response$data, response, _responseData$data3, _responseData$data4, _responseData$data5, _responseData$validat, responseData, _responseData$data, _responseData$data2, rejectionReason, message, _responseData$data6, _error$response, _errorData$data3, _errorData$data4, _errorData$validation, errorData, _errorData$data, _errorData$data2, _rejectionReason, _message, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetcher().post("/tabby/create-checkout-session", requestData);
        case 1:
          response = _context.v;
          if (!(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.success)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, response.data);
        case 2:
          responseData = response === null || response === void 0 ? void 0 : response.data; // Handle Tabby rejection when success === false and code === 200
          if (!((responseData === null || responseData === void 0 ? void 0 : responseData.success) === false && (responseData === null || responseData === void 0 ? void 0 : responseData.code) === 200)) {
            _context.n = 3;
            break;
          }
          rejectionReason = responseData === null || responseData === void 0 ? void 0 : (_responseData$data = responseData.data) === null || _responseData$data === void 0 ? void 0 : _responseData$data.rejection_reason;
          message = (responseData === null || responseData === void 0 ? void 0 : (_responseData$data2 = responseData.data) === null || _responseData$data2 === void 0 ? void 0 : _responseData$data2.message) || 'Payment rejected';
          if (!rejectionReason) {
            _context.n = 3;
            break;
          }
          throw new TabbyRejectionError(message, rejectionReason);
        case 3:
          if (!((responseData === null || responseData === void 0 ? void 0 : (_responseData$data3 = responseData.data) === null || _responseData$data3 === void 0 ? void 0 : _responseData$data3.error_type) === "order_already_paid")) {
            _context.n = 4;
            break;
          }
          throw new OrderPaidError('order_already_paid');
        case 4:
          if (!((responseData === null || responseData === void 0 ? void 0 : (_responseData$data4 = responseData.data) === null || _responseData$data4 === void 0 ? void 0 : _responseData$data4.error_type) === "post_reserved")) {
            _context.n = 5;
            break;
          }
          throw new PostReservedError('post_already_reserved');
        case 5:
          if (!((responseData === null || responseData === void 0 ? void 0 : (_responseData$data5 = responseData.data) === null || _responseData$data5 === void 0 ? void 0 : _responseData$data5.error_type) === "validation_error")) {
            _context.n = 6;
            break;
          }
          throw new ValidationException((responseData === null || responseData === void 0 ? void 0 : (_responseData$data6 = responseData.data) === null || _responseData$data6 === void 0 ? void 0 : _responseData$data6.message) || 'Validation error');
        case 6:
          if (!(responseData !== null && responseData !== void 0 && (_responseData$validat = responseData.validation_errors) !== null && _responseData$validat !== void 0 && _responseData$validat.length)) {
            _context.n = 7;
            break;
          }
          throw new TabbyValidationError(responseData.validation_errors);
        case 7:
          throw new Error('Unknown error');
        case 8:
          _context.n = 14;
          break;
        case 9:
          _context.p = 9;
          _t = _context.v;
          if (!(_t !== null && _t !== void 0 && (_error$response = _t.response) !== null && _error$response !== void 0 && _error$response.data)) {
            _context.n = 13;
            break;
          }
          errorData = _t.response.data; // Handle Tabby rejection from axios error response
          if (!((errorData === null || errorData === void 0 ? void 0 : errorData.success) === false && (errorData === null || errorData === void 0 ? void 0 : errorData.code) === 200)) {
            _context.n = 10;
            break;
          }
          _rejectionReason = errorData === null || errorData === void 0 ? void 0 : (_errorData$data = errorData.data) === null || _errorData$data === void 0 ? void 0 : _errorData$data.rejection_reason;
          _message = (errorData === null || errorData === void 0 ? void 0 : (_errorData$data2 = errorData.data) === null || _errorData$data2 === void 0 ? void 0 : _errorData$data2.message) || 'Payment rejected';
          if (!_rejectionReason) {
            _context.n = 10;
            break;
          }
          throw new TabbyRejectionError(_message, _rejectionReason);
        case 10:
          if (!((errorData === null || errorData === void 0 ? void 0 : (_errorData$data3 = errorData.data) === null || _errorData$data3 === void 0 ? void 0 : _errorData$data3.error_type) === "order_already_paid")) {
            _context.n = 11;
            break;
          }
          throw new OrderPaidError('order_already_paid');
        case 11:
          if (!((errorData === null || errorData === void 0 ? void 0 : (_errorData$data4 = errorData.data) === null || _errorData$data4 === void 0 ? void 0 : _errorData$data4.error_type) === "post_reserved")) {
            _context.n = 12;
            break;
          }
          throw new PostReservedError('post_already_reserved');
        case 12:
          if (!(errorData !== null && errorData !== void 0 && (_errorData$validation = errorData.validation_errors) !== null && _errorData$validation !== void 0 && _errorData$validation.length)) {
            _context.n = 13;
            break;
          }
          throw new TabbyValidationError(errorData.validation_errors);
        case 13:
          throw _t;
        case 14:
          return _context.a(2);
      }
    }, _callee, null, [[0, 9]]);
  }));
  return function api__createTabbyCheckoutSession(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__cancelTabbyOrder = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(requestData) {
    var _response$data2, response, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          _context2.n = 1;
          return fetcher().post("/tabby/order-cancel", requestData);
        case 1:
          response = _context2.v;
          if (!(response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.success)) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, response.data);
        case 2:
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t2 = _context2.v;
          throw _t2;
        case 4:
          return _context2.a(2);
      }
    }, _callee2, null, [[0, 3]]);
  }));
  return function api__cancelTabbyOrder(_x2) {
    return _ref2.apply(this, arguments);
  };
}();